'use client';
import { useSyncExternalStore } from 'react';
import useInheritParams from '@/hooks/useInheritParams';
import { URL_INHERIT_PARAMS } from '@/constants/urlInheritParams';
import { FlexibleFormBuilder } from './FlexibleFormBuilder';
import { isUsEmailHandoff } from './emailHandoffFlexibleFormSubmit';

interface EmailHandoffFlexibleFormProps {
    asset: SiteFlexibleForm;
    sxmGeo?: string;
}

const subscribe = () => () => {};
const getClientReady = () => true;
const getServerReady = () => false;

export function EmailHandoffFlexibleForm({ asset, sxmGeo }: EmailHandoffFlexibleFormProps) {
    // Keep SSR and the first hydration render disabled; enable only on the client.
    const ready = useSyncExternalStore(subscribe, getClientReady, getServerReady);
    const isUSA = ready ? isUsEmailHandoff() : isUsEmailHandoff(sxmGeo ?? '');
    const ctaUrl = asset.fields.cta?.fields.href?.trim() ?? '';
    const inheritedUrl = useInheritParams(ctaUrl, URL_INHERIT_PARAMS);
    const redirectUrl = ctaUrl ? inheritedUrl : undefined;

    return isUSA ? (
        <FlexibleFormBuilder asset={asset} emailHandoffUrl={redirectUrl} emailHandoffReady={ready && !!ctaUrl} />
    ) : null;
}
